import { render, staticRenderFns } from "./InputMedicines.vue?vue&type=template&id=16ad479d&scoped=true&"
import script from "./InputMedicines.vue?vue&type=script&lang=js&"
export * from "./InputMedicines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad479d",
  null
  
)

export default component.exports